import styled from "styled-components";

export const InfoContainer = styled.div`
  margin-top: 0.3rem;
`;
export const InfoHeader = styled.h5`
  font-weight: normal;
  font-size: 14px;
  margin: 0;
  margin-bottom: 0.175rem;
`;
